import { LoginForm } from "@/views/Login/LoginForm";

export const LoginPage: React.FC = () => <LoginForm />;
